"use strict";

window.Components.Buttons.Delete = createReactClass({
  onClick() {
    if (this.props.handler) {
      return this.props.handler();
    }
  },
  propTypes() {
    return {
      handler: PropTypes.func
    };
  },
  render() {
    return /* @__PURE__ */React.createElement("i", {
      className: "fa fa-times u-clickable",
      onClick: this.onClick
    });
  }
});